import React, { useState } from "react";
import QuizIcon from "@mui/icons-material/Quiz";
import Divider from "@mui/material/Divider";
import { useNavigate } from "react-router-dom";

const FAQ = () => {
  const navigate = useNavigate();
  const quesAns = [
    {
      ques: "What is codequeue?",
      ans: "Codequeue is a platform designed to offer personalized, one-on-one mentorship for IT students. It focuses on several key services like Mentorship, Interview Preparation & Tips, Mock Interviews, Career Guidance, Resume Review and many more",
    },
    {
      ques: "How can I connect?",
      ans: "You can connect to industry experts by booking the one-on-one session as per your choice what you are looking for!",
    },
    {
      ques: "How much will have to pay for sessions?",
      ans: "It's depend on the sessions you are going to schedule each service has different price and it can vary as per the mentor you are choosing",
    },
    {
      ques: "Is Codequeue really free?",
      ans: "Yes, But for only limited services are freely available, the session for that someone will drive you through the video call, you have to pay very minimal charges",
    },
  ];

  // State to track the currently opened question
  const [openIndex, setOpenIndex] = useState(null);

  const showAns = (index) => {
    setOpenIndex((prevIndex) => (prevIndex === index ? null : index));
  };

  const redirectToContact = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div className="my-40 flex flex-wrap justify-evenly">
      <div className="faqs-left w-full sm:w-full md:w-2/5 px-8 mb-8">
        <div className="text-4xl font-extrabold mb-3">
          Frequently asked questions
        </div>
        <div className="text-xl mb-3">
          Can't find the answer you are looking for?
        </div>
        <div className="text-xl text-blue-500 cursor-pointer" onClick={redirectToContact}>Reach out to us</div>
      </div>
      <div className="faqs-right w-full sm:w-full md:w-3/5 px-5 md:px-24">
        {quesAns.map((item, index) => (
          <div key={index}>
            <div
              onClick={() => showAns(index)}
              className={`flex justify-between items-center text-xl font-bold mt-10 cursor-pointer ${
                openIndex === index ? "text-blue-500" : ""
              }`}
            >
              <span>{item.ques}</span>
              <QuizIcon />
            </div>
            <div
              className={`overflow-hidden transition-all duration-1000 ease-in-out ${
                openIndex === index
                  ? "max-h-[1000px] opacity-100"
                  : "max-h-0 opacity-0"
              }`}
            >
              {openIndex === index && (
                <div className="mb-6 text-lg font-medium">{item.ans}</div>
              )}
            </div>
            <Divider />
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
